const files = [
require('/tmp/build/node_modules/universal-scripts/runtime.conf.d/client/20-helmet.js'),
require('/tmp/build/node_modules/universal-scripts/runtime.conf.d/client/22-css.js'),
require('/tmp/build/node_modules/universal-scripts/runtime.conf.d/client/30-redux.js'),
require('/tmp/build/node_modules/universal-scripts/runtime.conf.d/client/33-lang.js'),
require('/tmp/build/node_modules/universal-scripts/runtime.conf.d/client/50-render.js'),
require('/tmp/build/node_modules/universal-scripts/runtime.conf.d/client/70-router.js'),
]
const merge = (current, add) => {
          for (const key of Object.keys(add)) {
            current[key] = current[key] || []
            current[key].push(add[key])
          }
          return current
        }
const ret = files.reduce((acc, curr) => merge(acc, curr), {})
export default ret
